import { render, staticRenderFns } from "./WhatsappSetupWizard.vue?vue&type=template&id=3d8eccd1&scoped=true"
import script from "./WhatsappSetupWizard.vue?vue&type=script&lang=js"
export * from "./WhatsappSetupWizard.vue?vue&type=script&lang=js"
import style0 from "./WhatsappSetupWizard.vue?vue&type=style&index=0&id=3d8eccd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8eccd1",
  null
  
)

export default component.exports